import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";
import { PWC_URL } from "@util/constant";

/**
 * Component to render PwC Singapore section on Partners page
 */
const PwCSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="pwc-section-component">
      <AccordionV2
        testId="pwc"
        className="border-x py-4"
        headerChildren={<EventsAwardsAccordionHeader title="PwC Singapore" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            At PwC, our purpose is to build trust in society and solve important
            problems. We&apos;re a network of firms in 155 countries with over
            284,000 people who are committed to delivering quality in assurance,
            advisory and tax services. Find out more and tell us what matters to
            you by visiting us at&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={PWC_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.pwc.com/sg
            </a>
            .
          </p>

          <p>
            PwC refers to the PwC network and/or one or more of its member
            firms, each of which is a separate legal entity. Please see
            www.pwc.com/structure for further details.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default PwCSection;
